import React from 'react';
import type { BillingInvoiceSummary } from '../types/api';
import InvoicePdfView from './invoices/InvoicePdfView';

/**
 * Invoice drill-down detail: the Stripe invoice PDF, rendered inline.
 *
 * We show Stripe's own PDF rather than reconstructing line items / tax /
 * discounts ourselves — it is always correct and needs no schema upkeep. The
 * rendering itself lives in InvoicePdfView, shared with the dashboard. The
 * hosted-page link stays as a fallback / full-fidelity view.
 */
const HubSpotInvoiceDetail: React.FC<{ invoice: BillingInvoiceSummary }> = ({ invoice }) => {
  return (
    <div className="space-y-2 py-2">
      <InvoicePdfView invoiceId={invoice.stripe_invoice_id} />

      {invoice.hosted_invoice_url && (
        <a
          className="text-primary underline text-sm"
          href={invoice.hosted_invoice_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open invoice in Stripe ↗
        </a>
      )}
    </div>
  );
};

export default HubSpotInvoiceDetail;
